import React from 'react';
import { useTranslation } from 'react-i18next';
import './estilodashuser.css';

export default function Suporte() {
  const { t } = useTranslation();
  const supportReasons = t('dashboard.support.reasons', { returnObjects: true });

  return (
    <div className="content-page">
      <div className="content-card">
        <div className="content-page-header">
          <div>
            <h2>{t('dashboard.support.title')}</h2>
            <p>{t('dashboard.support.intro')}</p>
          </div>
        </div>

        <div className="suporte-grid">
          <div className="suporte-col">
            <div className="suporte-secao">
              <h3>{t('dashboard.support.service')}</h3>
              <p>
                📱{' '}
                <a
                  href="https://wa.me/5542984241307"
                  target="_blank"
                  rel="noreferrer"
                >
                  WhatsApp: (42) 98424-1307
                </a>
              </p>
              <p>
                📧 <a href="mailto:contato@quantumtrades.com.br">contato@quantumtrades.com.br</a>
              </p>
              <p>
                📧 <a href="mailto:suporte@quantumtrades.com.br">suporte@quantumtrades.com.br</a>
              </p>
              <p>
                📺{' '}
                <a
                  href="https://www.youtube.com/@QuantumTradesBR"
                  target="_blank"
                  rel="noreferrer"
                >
                  {t('dashboard.support.youtube')}
                </a>
              </p>
              <p>
                📨{' '}
                <a
                  href="https://t.me/QuantumTradesBr"
                  target="_blank"
                  rel="noreferrer"
                >
                  {t('dashboard.support.telegram')}
                </a>
              </p>
              <p>
                👥{' '}
                <a
                  href="https://t.me/+tdXvf6jsLSZmZjlh"
                  target="_blank"
                  rel="noreferrer"
                >
                  {t('dashboard.support.vip')}
                </a>
              </p>
            </div>
          </div>

          <div className="suporte-col">
            <div className="suporte-secao">
              <h3>{t('dashboard.support.when')}</h3>
              <ul>
                {Array.isArray(supportReasons) && supportReasons.map((reason) => (
                  <li key={reason}>{reason}</li>
                ))}
              </ul>
            </div>

            <div className="suporte-secao">
              <h3>{t('dashboard.support.broker')}</h3>
              <p>💹 {t('dashboard.support.brokerText')}</p>
              <p>
                <a
                  href="https://one.exnesstrack.org/a/hkga5cflzh"
                  target="_blank"
                  rel="noreferrer"
                  style={{ fontWeight: 'bold' }}
                >
                  {t('dashboard.support.brokerLink')}
                </a>
              </p>
            </div>
          </div>
        </div>

        <div className="cliente-help-box" style={{ marginTop: 18 }}>
          <strong>{t('dashboard.support.shortcutTitle')}</strong> {t('dashboard.support.shortcut')}
        </div>
      </div>
    </div>
  );
}
